import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const PlayControlWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  user-select: none;
`

export const IconSlot = styled.div<{ $disabled: boolean }>`
  position: relative;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.primaryExtraLight};
  border-radius: 50%;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`

// Stand-in "stop" icon shown while playing (no dedicated square asset exists).
export const StopSquare = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 1px;
  background-color: ${COLORS.primaryDark};
`

// Circular playback progress drawn around the stop square. Rotated so it
// starts filling from the top and runs clockwise.
export const ProgressRing = styled.svg`
  position: absolute;
  inset: 0;
  transform: rotate(-90deg);
  pointer-events: none;
`

export const ProgressTrack = styled.circle`
  fill: none;
  stroke: ${COLORS.primaryExtraLight};
  stroke-width: 2;
`

export const ProgressIndicator = styled.circle`
  fill: none;
  stroke: ${COLORS.primaryDark};
  stroke-width: 2;
  stroke-linecap: round;
  transition: stroke-dashoffset 0.1s linear;
`
